module.exports = __webpack_public_path__ + "img/queue.f13c7a47.svg";